export default __webpack_public_path__ + "static/media/AVAX.e1fb45e8.png";